const AUTH_API_URL = process.env.VUE_APP_AUTH_API_URL

function normalizeBaseUrl (baseUrl) {
  if (!baseUrl) return ''
  if (baseUrl === 'null' || baseUrl === 'undefined') return ''
  if (!/^https?:\/\//i.test(baseUrl)) return ''
  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl
}

function joinPath (a, b) {
  if (!a) return b || ''
  if (!b) return a
  const left = a.endsWith('/') ? a.slice(0, -1) : a
  const right = b.startsWith('/') ? b : `/${b}`
  return `${left}${right}`
}

async function postJson (path, body) {
  return await postJsonWithBase(AUTH_API_URL, path, body)
}

async function postJsonWithBase (base, path, body) {
  const baseUrl = normalizeBaseUrl(base)
  if (!baseUrl) {
    throw new Error('Auth API URL is not configured.')
  }

  // IMPORTANT: use the base URL exactly as provided.
  // - For HTTP API, set: https://<id>.execute-api.<region>.amazonaws.com
  // - For REST API stage, set: https://<id>.execute-api.<region>.amazonaws.com/v1
  const finalBase = baseUrl

  const res = await fetch(`${joinPath(finalBase, path)}`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body || {})
  })

  // Auth proxy intentionally returns generic responses; we still parse JSON when present.
  const text = await res.text()
  if (!text) return null
  try {
    return JSON.parse(text)
  } catch (_) {
    return null
  }
}

export const authProxyApi = {
  signup: async (payload) => postJson('/auth/signup', payload),
  forgotPassword: async (payload) => postJson('/auth/forgot-password', payload),
  resendConfirmation: async (payload) => postJson('/auth/resend-confirmation', payload),
  login: async (payload) => postJson('/auth/login', payload),
  confirmSignup: async (payload) => postJson('/auth/confirm-signup', payload),
  confirmForgotPassword: async (payload) => postJson('/auth/confirm-forgot-password', payload),
  mfaVerify: async (payload) => postJson('/auth/mfa-verify', payload),
  mfaSetup: async (payload) => postJson('/auth/mfa-setup', payload),
  mfaConfirm: async (payload) => postJson('/auth/mfa-confirm', payload),
  mfaDisable: async (payload) => postJson('/auth/mfa-disable', payload),
  mfaStatus: async (payload) => postJson('/auth/mfa-status', payload)
}
